import { numberFormatters } from "common";
import { getFormattedDateAlignWithUserSettings, trimDateString } from "common/date-utils";
import { NumberFormatKind } from "common/types";
import { language } from "language/default";
export const moduleName = "campaignModule";
export const getContextMenuItems = (params) => {
    const newItems = params.defaultItems.filter((e) => e !== "export");
    return newItems;
};
export const percentageFormatter = (params) => numberFormatters(Math.round(params.value * 100) / 100, NumberFormatKind.percent, { minimumFractionDigits: 0 });
export const dateFormatter = (params) => {
    if (!params.value) {
        return "";
    }
    return trimDateString(getFormattedDateAlignWithUserSettings(new Date(`${params.value.year}-${params.value.month}-${params.value.day}`)));
};
export const booleanFormatter = (params) => (params.value ? "Yes" : "No");
export const formatPercentage = (value) => numberFormatters(Math.round(value * 100) / 100, NumberFormatKind.percent, { minimumFractionDigits: 0 });
export const campaignSummaryToGridRows = (summary) => [
    {
        numberOfSubmissions: summary.validated.value,
        percentageOfSubmissions: summary.validated.percentage,
        popoverLabel: language.en.campaigns.summaryPopoverLabels.validated,
        status: language.en.campaigns.summaryLabels.validated
    }, {
        numberOfSubmissions: summary.submittedForValidation.value,
        percentageOfSubmissions: summary.submittedForValidation.percentage,
        popoverLabel: language.en.campaigns.summaryPopoverLabels.submittedForValidation,
        status: language.en.campaigns.summaryLabels.submittedForValidation
    }, {
        numberOfSubmissions: summary.pending.value,
        percentageOfSubmissions: summary.pending.percentage,
        status: language.en.campaigns.summaryLabels.pending
    }, {
        numberOfSubmissions: summary.pendingWithoutReports.value,
        percentageOfSubmissions: summary.pendingWithoutReports.percentage,
        popoverLabel: language.en.campaigns.summaryPopoverLabels.pendingWithoutReports,
        status: language.en.campaigns.summaryLabels.pendingWithoutReports
    }, {
        numberOfSubmissions: summary.pendingWithReports.value,
        percentageOfSubmissions: summary.pendingWithReports.percentage,
        popoverLabel: language.en.campaigns.summaryPopoverLabels.pendingWithReports,
        status: language.en.campaigns.summaryLabels.pendingWithReports
    }, {
        numberOfSubmissions: summary.awaitingAdditionalReports.value,
        percentageOfSubmissions: summary.awaitingAdditionalReports.percentage,
        popoverLabel: language.en.campaigns.summaryPopoverLabels.awaitingAdditionalReports,
        status: language.en.campaigns.summaryLabels.awaitingAdditionalReports
    }, {
        numberOfSubmissions: summary.declined.value,
        percentageOfSubmissions: summary.declined.percentage,
        popoverLabel: language.en.campaigns.summaryPopoverLabels.declined,
        status: language.en.campaigns.summaryLabels.declined
    }, {
        numberOfSubmissions: summary.cancelled.value,
        percentageOfSubmissions: summary.cancelled.percentage,
        popoverLabel: language.en.campaigns.summaryPopoverLabels.cancelled,
        status: language.en.campaigns.summaryLabels.cancelled
    }
];
